export enum Variant {
  FLOATING_ACTION_BUTTON = 'floating-action-button',
  FLOATING_ACTION_CARD = 'floating-action-card',
  FLOATING_INPUT_CARD = 'floating-input-card',
  EMBEDDED = 'embedded',
}
